module.exports = __webpack_public_path__ + "static/media/dpsicon.439afdf0.svg";